var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardAddButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Card_Add_button",
    "data-name": "Card Add button",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_574",
    "data-name": "Path 574",
    d: "M12.5,0A12.5,12.5,0,1,1,0,12.5,12.5,12.5,0,0,1,12.5,0Z",
    fill: "#00246a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Union_88_-_Outline",
    "data-name": "Union 88 - Outline",
    d: "M24065.531-10336.657a.5.5,0,0,1,.5.5v2.5h2.5a.5.5,0,0,1,.5.5.5.5,0,0,1-.5.5h-2.5v2.5a.5.5,0,0,1-.5.5.5.5,0,0,1-.5-.5v-2.5h-2.5a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2.5v-2.5A.5.5,0,0,1,24065.531-10336.657Z",
    transform: "translate(-24053.031 10345.657)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardAddButton);
export default __webpack_public_path__ + "static/media/CardAddButton.70ad30ae9fcc9db1b03704bdcdcddce3.svg";
export { ForwardRef as ReactComponent };